import { MenuItem, TextField, TextFieldProps } from "@mui/material";
import { useMemo, useState } from "react";
import { useMediaDevices } from "react-media-devices";
import { Outlet, useRouteLoaderData } from "react-router-dom";
import { AutoPagePaperLayout } from "./Layouts/AutoPagePaperLayout";
import { PageActions, PageBreadcrumbs, PageTitle } from "./Layouts/components/PageTitleContainer";
import { Pickup } from "types/pickup";

const DeviceDropdown = (props: TextFieldProps) => {
  const { devices, loading } = useMediaDevices({ constraints: { video: true } });

  const videoDevices: MediaDeviceInfo[] = useMemo(() => {
    return devices?.filter((device) => device.kind == "videoinput") || [];
  }, [devices]);

  const deviceOptions = useMemo(() => {
    return videoDevices.map((device, index) => (
      <MenuItem key={index} value={device.deviceId}>
        {device.label}
      </MenuItem>
    ));
  }, [videoDevices]);

  return (
    <TextField
      {...props}
      select
      label="Video Device"
      placeholder="Select a video device"
      size="small"
      sx={{ minWidth: 200 }}
    >
      {loading ? <MenuItem disabled>Fetching video devices...</MenuItem> : deviceOptions}
    </TextField>
  );
};

export default function InboundPhotosLayout() {
  const [activeDeviceId, setActiveDeviceId] = useState(localStorage.getItem("activeDeviceId") || "");
  const { pickup } = useRouteLoaderData("pickup") as { pickup: Pickup };

  return (
    <AutoPagePaperLayout paperProps={{ sx: { p: 2 } }}>
      <PageTitle>Add Photos</PageTitle>
      <PageBreadcrumbs
        links={[
          { label: "Warehouse" },
          { label: "Pickups", path: "/pickups" },
          { label: `Pickup ${pickup.id}`, path: `/pickups/${pickup.id}` },
        ]}
      />
      <PageActions>
        <DeviceDropdown
          onChange={(e) => {
            setActiveDeviceId(e.target.value);
            localStorage.setItem("activeDeviceId", e.target.value);
          }}
          value={activeDeviceId}
        />
      </PageActions>
      <Outlet context={{ activeDeviceId }} />
    </AutoPagePaperLayout>
  );
}
